module.exports = __webpack_public_path__ + "static/media/logo_wind.03a029df.svg";